<template>
  <div id="kclist">
     <el-select v-model="para.isEnd" placeholder="请选择" @change="handleChange()">
        <el-option value="N" label="有效">有效</el-option>
        <el-option value="Y" label="无效">无效</el-option>
    </el-select>
    <div class="comond_btn" v-if="(roleCode === 'administrator' || roleCode === 'admin')">
      <el-button  @click="handleAdd()" >新增库存信息</el-button>
    </div>
    <template>
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="cnName"
          label="商品中文名"
          width="">
        </el-table-column>
         <el-table-column
          prop="enName"
          label="商品英文名"
          width="">
        </el-table-column>
        <el-table-column
          prop="model"
          label="型号">
        </el-table-column>
        <el-table-column
          prop="packWeight"
          label="包装规格">
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="生产商">
        </el-table-column>
        <el-table-column
          prop="safety"
          label="总数量">
        </el-table-column>
        <el-table-column
          label="操作选项">
           <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handlequery(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        width="35%"
        center>
        <el-form :model="form">
          <el-form-item label="仓储公司" :label-width="formLabelWidth">
            <el-select v-model="form.companyId" placeholder="请选择" @change="handlechangestock">
                <el-option
                v-for="item in stocklist"
                :key="item.key"
                :label="item.chineseName?item.chineseName:item.englishName"
                :value="item.id">
                <span style="float: left">{{ item.chineseName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="仓储地址" :label-width="formLabelWidth">
            <el-select v-model="form.address" placeholder="请选择">
                <el-option
                v-for="item in stockadresslist"
                :key="item.key"
                :label="item.address"
                :value="item.address">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="船务" :label-width="formLabelWidth">
            <el-select v-model="form.shipBusinessId" placeholder="请选择">
               <el-option
                  v-for="n in shiplist"
                  :key="n.key"
                  :label="n.contractNum"
                  :value="n.id">
                </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="清关税" :label-width="formLabelWidth">
            <el-input v-model="form.clearanceDuty"></el-input>
          </el-form-item>

          <el-form-item label="币种" :label-width="formLabelWidth" prop="brokerId">
            <el-select v-model="form.currencyCode" placeholder="请选择">
              <el-option
                v-for="item in crmcurrencyList"
                :key="item.key"
                :label="item.currency"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>

           <el-form-item label="清关汇率" :label-width="formLabelWidth">
            <el-input v-model="form.exchangeRate"></el-input>
          </el-form-item>

          <el-form-item label="入库时间" :label-width="formLabelWidth">
             <el-date-picker
              v-model="form.entryTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="采购合同号pdf" class="cghthstyle" label-width="120px" style="margin-left:34px;">
            
            <el-upload
              class="upload-demo"
              :data="qiniu"
              action="https://upload.qiniup.com"
              :show-file-list="true"
              :multiple="false"
              :file-list="purchaseContract"
              :before-upload="(file) => {return handleBeforeUpload(file, 'purchaseContract')}"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'purchaseContract') }"
              :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'purchaseContract') }"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="进口货物报关单" class="cghthstyle" label-width="120px" style="margin-left:34px;">
            
            <el-upload
              class="upload-demo"
              :data="qiniu"
              action="https://upload.qiniup.com"
              :show-file-list="true"
              :multiple="false"
              :file-list="cargoDeclaration"
              :before-upload="(file) => {return handleBeforeUpload(file, 'cargoDeclaration')}"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'cargoDeclaration') }"
              :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'cargoDeclaration') }"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>


          <el-form-item label="进仓核验单" class="cghthstyle" label-width="120px" style="margin-left:34px;">
            
            <el-upload
              class="upload-demo"
              :data="qiniu"
              action="https://upload.qiniup.com"
              :show-file-list="true"
              :multiple="false"
              :file-list="verifySingle"
              :before-upload="(file) => {return handleBeforeUpload(file, 'verifySingle')}"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'verifySingle') }"
              :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'verifySingle') }"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="核酸检测" class="cghthstyle" label-width="120px" style="margin-left:34px;">
            
            <el-upload
              class="upload-demo"
              :data="qiniu"
              action="https://upload.qiniup.com"
              :show-file-list="true"
              :multiple="false"
              :file-list="nucleicAcidProof"
              :before-upload="(file) => {return handleBeforeUpload(file, 'nucleicAcidProof')}"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'nucleicAcidProof') }"
              :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'nucleicAcidProof') }"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

           <el-form-item label="核酸检测费用" :label-width="formLabelWidth">
            <el-input v-model="form.nucleicAcidProofCost"></el-input>
          </el-form-item>


          <el-form-item label="消杀" class="cghthstyle" label-width="120px" style="margin-left:34px;">
            
            <el-upload
              class="upload-demo"
              :data="qiniu"
              action="https://upload.qiniup.com"
              :show-file-list="true"
              :multiple="false"
              :file-list="disinfectionCertificate"
              :before-upload="(file) => {return handleBeforeUpload(file, 'disinfectionCertificate')}"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'disinfectionCertificate') }"
              :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'disinfectionCertificate') }"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="消杀检测费用" :label-width="formLabelWidth">
            <el-input v-model="form.disinfectCostcost"></el-input>
          </el-form-item>
          
          <el-form-item label="备注" :label-width="formLabelWidth">
            <el-input v-model="form.remark"></el-input>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handlesuccess()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { stockquerystock, stocklocationfindAll, addressfindByCompanyId, shipfindAll, findAll, qiniuupload, stockadd, crmcurrency } from '../../api'
import utils from '../../../public/utils'
import qs from 'qs'
import moment from 'moment'
export default {
  data () {
    return {
      list: [],
      formLabelWidth: '120px',
      centerDialogVisible: false,
      purchaseContract: [],
      form: {
        companyId: '', //  库位ID
        shipBusinessId: '', //  船务ID
        purchaseContract: '', //  采购合同
        cargoDeclaration: '',
        verifySingle: [],
        nucleicAcidProof:[],
        disinfectionCertificate:[],
        nucleicAcidProofCost:'',
        disinfectCostcost:'',
      },
      crmcurrencyList: [],
      cargoDeclaration: [],
      verifySingle: [],
      nucleicAcidProof: [],
      disinfectionCertificate:[],
      xsImg: [],
      title: '', //  添加窗口标题
      stocklist: [], //  库位列表
      stockadresslist: [], //  仓储地址列表
      shiplist: [], //  船务列表
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      uploadUrl: '', //  上传地址前缀
      roleCode: '',
      para: {
        isEnd: 'N',
      }
    }
  },
  mounted () {
    this.getstockquerystock()
    this.getToken()
    let roleCode = sessionStorage.getItem('roleCode')
    console.log(roleCode)
    this.roleCode = roleCode
  },
  methods: {
    getToken () { //  获取qiniu的token
      let para = new URLSearchParams()
      para.append('bucket', 'compact')
      qiniuupload(para).then((res) => {
        console.log(res.data)
        this.qiniu.token = res.data.uploadToken
        this.uploadUrl = res.data.url
      })
    },
    handleChange () {
      this.getstockquerystock()
    },
    handlechangestock (val) {
      console.log(val)
      this.getaddressfindByCompanyId(val)
    },
    getaddressfindByCompanyId (companyId) {
      let para = {
        companyId: companyId,
        typeId: 3
      }
      addressfindByCompanyId(para).then(data => {
        console.log(data)
        this.stockadresslist = data.data.data
        // this.stockadresslist.push()
      })
    },
    getcrmcurrency () { //  货币列表
      let para = {}
      crmcurrency(para).then(data => {
        console.log(data)
        this.crmcurrencyList = data.data.data
      })
    },
    handleBeforeUpload (file, type) { //  上传之前
      this.qiniu.key = type + `${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess (response, file, fileList, type) { //  上传成功之后
      this.form[type] = this.uploadUrl + '/' + response.key
      this[type].push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
    },
    handleOnRemove (file, fileList, type) {
      this[type] = []
    },
    handlequery (row) { //  查看详情
      row['isEnd'] = this.para.isEnd
      this.$router.push({ path: '/kcdetail', query: { name: row }}) 
    },
    handleAdd () { //  新增
      this.centerDialogVisible = true
      this.title = '新增库存信息'
      this.form = {}
      this.purchaseContract = []
      this.cargoDeclaration = []
      this.verifySingle = []
      this.nucleicAcidProof = []
      this.disinfectionCertificate = []
      this.getstocklocationfindAll()
      this.getshipfindAll()
      this.getcrmcurrency()
    },
    handlesuccess () { //  提交表单信息
      // this.form.shipBusinessId = 1
      this.form.entryTime = this.formatime(this.form.entryTime)
      let para = new URLSearchParams(this.form)
      stockadd(para).then(data => {
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getstockquerystock()
          this.centerDialogVisible = false
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    getstockquerystock () { //  查询全部库存

      let params = new URLSearchParams(this.para)
      stockquerystock(params).then(data => {
        console.log(data)
        this.list = data.data
      })
    },
    getstocklocationfindAll () { //  库位列表
      // let para = {
      //   status: 1
      // }
      // stocklocationfindAll(para).then(data => {
      //   console.log(data.data.data)
      //   this.stocklist = data.data.data
      // })
      let para = {
        'status': 1,
        'typeId': 8
      }
      findAll(para).then(data => {
        console.log(data)
        this.stocklist = data.data.data
        this.stocklist.push({id: 0, chineseName: '直接发货'})
      })
    },
    getshipfindAll () { //  船务列表
      let para = {
        travelPosition: 2,
        status: 1
      }
      shipfindAll(para).then(data => {
        console.log(data)
        this.shiplist = data.data.data.rows
      })
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
  },
}
</script> 
<style lang="stylus" scoped>
#kclist
  .comond_btn
    display flex
    justify-content flex-end
    margin-bottom 30px
    button
      background-color #0a3d5f
      color #fff
  .cghthstyle
    label
      line-height 20px
</style>
